import { useCallback } from 'react';
import type { AnalyticsCmsDashboard } from '@/types/analytics/dashboard';
import { getCmsDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsCmsDashboard = {
  published: 0,
  updated: 0,
  archived: 0,
  draft: 0,
  pendingReview: 0,
  lastActivityAt: null,
  byEditor: [],
};

export function useAnalyticsCms() {
  const loader = useCallback(() => getCmsDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
